import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ForgotPasswordModel } from './forgotpassword.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse } from '../../shared/config'

@Injectable()
export class ForgotPasswordService {
  constructor(private authService: AuthService, private http: Http) { }

  public CheckActivationCode(activationCode: string): Observable<IAPIResponse> {
    let getActivationUrl = WeGoConfig.API_GET_CHECKACTIVATIONCODE + "?activationCode=" + activationCode;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getActivationUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public SubmitUser(forgotpasswordModal: ForgotPasswordModel): Observable<IAPIResponse> {
    let body = forgotpasswordModal;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_FORGOTPASSSWORD, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public SubmitChangePassword(forgotpasswordModal: ForgotPasswordModel): Observable<IAPIResponse> {
    let body = forgotpasswordModal;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_CHANGEPASSSWORD, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/forgotpassword/models/forgotpassword.service.ts